var _defs, _g, _g2, _path, _path2, _path3, _g3, _g4, _circle, _circle2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeslaR(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f1f5ff;stroke:#353841;stroke-width:1.5px;}.b,.d{fill:#71778a;}.c,.h{fill:#cad0e4;}.e{fill:#353841;}.f,.h{stroke:none;}.g{fill:none;}.i{filter:url(#c);}.j{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 37,
    y: 28,
    width: 18,
    height: 18,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 19,
    y: 28,
    width: 18,
    height: 18,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 74,
    height: 74,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 0.75,
    y: 0.75,
    width: 72.5,
    height: 72.5,
    rx: 11.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(16 16)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 21 40.5 C 18.36685943603516 40.5 15.81326961517334 39.9846305847168 13.41018009185791 38.96820831298828 C 11.08831024169922 37.98614120483398 9.002750396728516 36.57991027832031 7.211420059204102 34.78858184814453 C 5.420090198516846 32.99724960327148 4.01386022567749 30.91168975830078 3.031790018081665 28.58982086181641 C 2.015369892120361 26.18672943115234 1.5 23.63314056396484 1.5 21 C 1.5 18.36685943603516 2.015369892120361 15.81326961517334 3.031790018081665 13.41018009185791 C 4.01386022567749 11.08831024169922 5.420090198516846 9.002750396728516 7.211420059204102 7.211420059204102 C 9.002750396728516 5.420090198516846 11.08831024169922 4.01386022567749 13.41018009185791 3.031790018081665 C 15.81326961517334 2.015369892120361 18.36685943603516 1.5 21 1.5 C 23.63314056396484 1.5 26.18672943115234 2.015369892120361 28.58982086181641 3.031790018081665 C 30.91168975830078 4.01386022567749 32.99724960327148 5.420090198516846 34.78858184814453 7.211420059204102 C 36.57991027832031 9.002750396728516 37.98614120483398 11.08831024169922 38.96820831298828 13.41018009185791 C 39.9846305847168 15.81326961517334 40.5 18.36685943603516 40.5 21 C 40.5 23.63314056396484 39.9846305847168 26.18672943115234 38.96820831298828 28.58982086181641 C 37.98614120483398 30.91168975830078 36.57991027832031 32.99724960327148 34.78858184814453 34.78858184814453 C 32.99724960327148 36.57991027832031 30.91168975830078 37.98614120483398 28.58982086181641 38.96820831298828 C 26.18672943115234 39.9846305847168 23.63314056396484 40.5 21 40.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M 21 3 C 16.19202995300293 3 11.67182922363281 4.872329711914063 8.272079467773438 8.272079467773438 C 4.872329711914063 11.67182922363281 3 16.19202995300293 3 21 C 3 25.80797004699707 4.872329711914063 30.32817077636719 8.272079467773438 33.72792053222656 C 11.67182922363281 37.12767028808594 16.19202995300293 39 21 39 C 25.80797004699707 39 30.32817077636719 37.12767028808594 33.72792053222656 33.72792053222656 C 37.12767028808594 30.32817077636719 39 25.80797004699707 39 21 C 39 16.19202995300293 37.12767028808594 11.67182922363281 33.72792053222656 8.272079467773438 C 30.32817077636719 4.872329711914063 25.80797004699707 3 21 3 M 21 0 C 32.59798049926758 0 42 9.402019500732422 42 21 C 42 32.59798049926758 32.59798049926758 42 21 42 C 9.402019500732422 42 0 32.59798049926758 0 21 C 0 9.402019500732422 9.402019500732422 0 21 0 Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M16,0A16,16,0,1,1,0,16,16,16,0,0,1,16,0Z",
    transform: "translate(21 21)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M5,0H5a5,5,0,0,1,5,5v7a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z",
    transform: "translate(32 42)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M5,0H5a5,5,0,0,1,5,5v7a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z",
    transform: "translate(42 32) rotate(180)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "j",
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(40 31)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(22 31)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(44 35)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(26 35)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(35 25)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(35 45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeslaR);
export default __webpack_public_path__ + "static/media/tesla_r.ab0445ce79a0f8e04362b7b08988c3c4.svg";
export { ForwardRef as ReactComponent };